export const USER_MULTI_VALUE_LIST_MORE_ITEM_AVATAR_SIZE = 32
